import { render, staticRenderFns } from "./App.vue?vue&type=template&id=71c6923e&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=71c6923e&prod&scoped=true&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=71c6923e&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c6923e",
  null
  
)

export default component.exports